export default [
    {
        path: '/loginForUpgrades', // 机场员工登陆
        component: resolve => require(['@/pages/upgrades/loginForUpgrades'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/getQr', // 获取二维码
        component: resolve => require(['@/pages/upgrades/getQr'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/selectEntrance', // 选择服务
        component: resolve => require(['@/pages/upgrades/selectEntrance'], resolve),
    },
    {
        path: '/upgradesTrip', // 选取行程
        component: resolve => require(['@/pages/upgrades/trip'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/ugfillorder', // 升舱填写订单  upgradesDetail
        component: resolve => require(['@/pages/upgrades/ugfillorder'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/upgradesDetail', // 升舱订单详情  
        component: resolve => require(['@/pages/upgrades/upgradesDetail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/upgradesPaySuccess', // 支付成功页
        component: resolve => require(['@/pages/upgrades/upgradesPaySuccess'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/upgradesPayFail', // 支付失败页
        component: resolve => require(['@/pages/upgrades/upgradesPayFail'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/upgradesInvoice', // 支付状态页
        component: resolve => require(['@/pages/upgrades/upgradesInvoice'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/upgradesNeedKnow', // 值机柜台升舱须知
        component: resolve => require(['@/pages/upgrades/upgradesNeedKnow'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/upgradesOrderList', // 升舱订单列表
        component: resolve => require(['@/pages/upgrades/upgradesOrderList'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/selectQrType', // 选择二维码类型
        component: resolve => require(['@/pages/upgrades/selectQrType'], resolve),
        meta: { title: "长龙航空" }
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/upgrades.js